/**
 * Shared download + Share & Earn CTA lines for share cards / texts.
 * Share targets = Google Play + Microsoft Store only (no website).
 */

/** Live Google Play listing (no referral). */
export const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.pianotutor.ultimateclassic";

/** Live Microsoft Store listing. */
export const MS_STORE_URL = "https://apps.microsoft.com/detail/9P9WSTJSPC2G";

/**
 * Primary install / share URL (Play Store).
 * Optional override: localStorage `uptDownloadUrl`
 */
export const APP_DOWNLOAD_URL =
  (typeof localStorage !== "undefined" &&
    localStorage.getItem("uptDownloadUrl")?.trim()) ||
  PLAY_STORE_URL;

/** Play Store URL that carries a referral for Install Referrer + manual fallback. */
export function buildPlayStoreReferralUrl(code: string): string {
  const c = code.trim().toUpperCase();
  if (!c) return PLAY_STORE_URL;
  const referrer = `utm_source=upt_ref&utm_medium=share&utm_content=${c}`;
  return `${PLAY_STORE_URL}&referrer=${encodeURIComponent(referrer)}`;
}

/** Microsoft Store URL with ?ref=CODE (enter at Sign in on Windows). */
export function buildMsStoreReferralUrl(code: string): string {
  const c = code.trim().toUpperCase();
  if (!c) return MS_STORE_URL;
  try {
    const u = new URL(MS_STORE_URL);
    u.searchParams.set("ref", c);
    return u.toString();
  } catch {
    return `${MS_STORE_URL}?ref=${encodeURIComponent(c)}`;
  }
}

/** Compelling Play + Microsoft download lines (no website). */
export function downloadCtaLine(code?: string): string {
  const c = code?.trim().toUpperCase() || "";
  const play = c ? buildPlayStoreReferralUrl(c) : PLAY_STORE_URL;
  const ms = c ? buildMsStoreReferralUrl(c) : MS_STORE_URL;
  let line =
    `🎹 Abhi free download karo — classic piano asani se seekho (classes, MIDI, exams & certificate)!\n\n` +
    `📱 Android — Google Play:\n${play}\n\n` +
    `💻 Windows — Microsoft Store:\n${ms}`;
  if (c) {
    line += `\n\n🔑 Sign in pe ye referral code bharo (agar auto-fill na ho): ${c}`;
  }
  return line;
}

/** Learn piano + store CTAs — used on share texts. */
export function viralShareFooter(opts?: { referralHint?: boolean; referralCode?: string }): string {
  const earn =
    opts?.referralHint !== false
      ? `Share & Earn: dost ko invite karo — Full Course buy par reward mil sakta hai.\n\n`
      : "";
  return (
    `Classic piano asani se seekho — Campaign lessons, MIDI, exams & certificate.\n\n` +
    earn +
    `${downloadCtaLine(opts?.referralCode)}\n\n` +
    `#UltimatePianoTutor #LearnPiano #ShareAndEarn`
  );
}

export function setAppDownloadUrl(url: string): void {
  try {
    localStorage.setItem("uptDownloadUrl", url.trim());
  } catch {
    /* ignore */
  }
}

export function setMsStoreUrl(url: string): void {
  try {
    localStorage.setItem("uptMsStoreUrl", url.trim());
  } catch {
    /* ignore */
  }
}
